<dx-popup [title]="title"
          [visible]="isVisible"
          [shading]="true"
          [resizeEnabled]="false"
          [closeOnOutsideClick]="false"
          [width]="350"
          [height]="330"
          (onHiding)="closeDialog()">
  <div class="about-container">
    <div class="about-item">
      <div translate>Username:</div>
      <div>{{ about.username }}</div>
    </div>
    <div class="about-item">
      <div translate>WebUI version:</div>
      <div>{{ about.webUIVersion }}</div>
    </div>
    <div class="about-item">
      <div translate>WebAPI version:</div>
      <div>{{ about.webAPIVersion }}</div>
    </div>
    <div class="about-item">
      <div translate>Database:</div>
      <div>{{ about.database }}</div>
    </div>
    <div class="about-item">
      <div translate>Database version:</div>
      <div>{{ about.databaseVersion }}</div>
    </div>
    <div class="about-item">
      <div translate>Servername:</div>
      <div>{{ about.serverName }}</div>
    </div>
  </div>
  <div>
    <dx-button id="btnClose" text="{{'Close' | translate}}" type="success" (click)="closeDialog()"></dx-button>
  </div>
</dx-popup>
